import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

export const usePreviousRoute = () => {
  const router = useRouter();
  const prevPath = useRef<string>("");

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      prevPath.current = router.asPath;
    };

    router.events.on("routeChangeStart", handleRouteChange);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router]);

  return prevPath.current;
};